var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visit-success-page"},[_c('div',{staticClass:"title"},[_vm._v(" Face Club COVID-19 Tracking ")]),(_vm.serverError)?_c('div',{staticClass:"info"},[_vm._v(" "+_vm._s(_vm.serverError)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }